module.exports = __webpack_public_path__ + "static/img/yf_03.9e4aa2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yf/yf_03.jpg
// module id = Erur
// module chunks = 1